export const i18nKeys = {
  core: {
    common: {
      ok: 'core.common.ok',
      cancel: 'core.common.cancel',
      close: 'core.common.close',
      save: 'core.common.save',
      yes: 'core.common.yes',
      upload: 'core.common.upload',
      uploadPhoto: 'core.common.uploadPhoto',
      create: 'core.common.create',
      remove: 'core.common.remove',
      submit: 'core.common.submit',
      expand: 'core.common.expand',
      collapse: 'core.common.collapse',
      showMore: 'core.common.showMore',
      showLess: 'core.common.showLess',
      createdMessage: 'core.common.createdMessage',
      savedMessage: 'core.common.savedMessage',
      savedErrrorMessage: 'core.common.savedErrorMessage',
      removedMessage: 'core.common.removedMessage',
      import: 'core.common.import',
      importDone: 'core.common.importDone',
      importFailed: 'core.common.importFailed',
      selectEmptyOptionText: 'core.common.selectEmptyOptionText',
      suggest: {
        noResults: 'core.common.suggest.noResults',
      },
      multiselect: {
        noResults: 'core.common.multiselect.noResults',
      },
      chooseFile: 'core.common.chooseFile',
      dragUploadFile: 'core.common.dragUploadFile',
      attachments: 'core.common.attachments',
      unknownPerson: 'core.common.unknownPerson',
      validationError: 'core.common.validationError',
      etagvalidationError: 'core.common.etagvalidationError',
    },
    title: 'title',
    loading: {
      user: 'loadingUser',
    },
    gator: {
      name: {
        label: 'name.label',
      },
      age: {
        label: 'age.label',
      },
      home: {
        label: 'home.label',
      },
    },
  },
  auth: {
    login: 'login',
    logout: 'logout',
    forgotPassword: 'forgotPassword',
    resetPassword: 'resetPassword',
    reloadApplication: 'auth.reloadApplication',
    expiredLoginInfo: 'auth.expiredLoginInfo',
  },
  admin: {
    title: 'admin.title',
    import: {
      label: 'admin.import.label',
      table: {
        line: 'admin.import.table.line',
        heading: 'admin.import.table.heading',
        headingSkipped: 'admin.import.table.headingSkipped',
      },
    },
    common: {
      backToList: 'admin.common.backToList',
      ok: 'admin.common.ok',
      cancel: 'admin.common.cancel',
      save: 'admin.common.save',
      saveAndReturn: 'admin.common.saveAndReturn',
      create: 'admin.common.create',
      edit: 'admin.common.edit',
      export: 'admin.common.export',
      fullExport: 'admin.common.fullExport',
      midYearMeetingExport: 'admin.common.midYearMeetingExport',
      endYearMeetingExport: 'admin.common.endYearMeetingExport',
      viewGoals: 'admin.common.viewGoal',
      delete: 'admin.common.delete',
      endYearCalculationExport: 'admin.common.endYearCalculationExport',
      endYearCalibrationNotesExport: 'admin.common.endYearCalibrationNotesExport',
      managerAssessmentOverallTemplate: 'admin.common.managerAssessmentOverallTemplate',
      exportPersonHistory: 'admin.common.exportPersonHistory',
      exportPersonHistoryDialogHeader: 'admin.common.exportPersonHistoryDialogHeader',
      exportPersonHistoryDialogFrom: 'admin.common.exportPersonHistoryDialogFrom',
      exportPersonHistoryDialogTo: 'admin.common.exportPersonHistoryDialogTo',
      personHistoryTitle: 'admin.common.personHistoryTitle',
    },
    filters: {
      search: 'admin.filters.search',
      clear: 'admin.filters.clear',
      labelOrganization: 'admin.filters.labelOrganization',
      labelLevel: 'admin.filters.labelLevel',
      labelFunction: 'admin.filters.labelFunction',
      labelStatus: 'admin.filters.labelStatus',
      labelDepartment: 'admin.filters.labelDepartment',
      labelBonusPeriods: 'admin.filters.labelBonusPeriod',
      noOptionTextOrganization: 'admin.filters.defaultAll',
      noOptionTextLevel: 'admin.filters.defaultAll',
      noOptionTextFunction: 'admin.filters.defaultAll',
      noOptionTextDisabled: 'admin.filters.defaultAll',
      reviewType: 'admin.filters.reviewType',
    },
    organizations: {
      label: 'admin.organizations.label',

      form: {
        name: 'admin.organizations.form.name',
        code: 'admin.organizations.form.code',
        parentOrganization: 'admin.organizations.form.parentOrganization',
        defaultLanguage: 'admin.organizations.form.defaultLanguage',
        editionPublishingSettings: 'admin.organizations.form.editionPublishingSettings',
        editionPublishingSettingsTitle: 'admin.organizations.form.editionPublishingSettingsTitle',
        allowPublishing: 'admin.organizations.form.allowPublishing',
        available: 'admin.organizations.form.available',
        nonAvailable: 'admin.organizations.form.nonAvailable',
        reviewType: 'admin.organizations.form.reviewType',
        publishingSettingsSaved: 'admin.organizations.form.publishingSettingsSaved',
        settings: 'admin.organizations.form.settings',
        organization: 'admin.organizations.form.organization',
        update: 'admin.organizations.form.update',
        create: 'admin.organizations.form.create',
        identification: 'admin.organizations.form.identification',
      },

      table: {
        id: 'admin.organizations.table.id',
        code: 'admin.organizations.table.code',
        name: 'admin.organizations.table.name',
        parentOrgUnit: 'admin.organizations.table.parentOrgUnit',
        actions: 'admin.organizations.table.actions',
      },
    },

    bonusPeriod: {
      label: 'admin.bonusPeriod.label',

      state: {
        moveToActive: 'admin.bonusPeriod.state.moveToActive',
        moveToDraft: 'admin.bonusPeriod.state.moveToDraft',
        moveToFinished: 'admin.bonusPeriod.state.moveToFinished',
      },
      setDefault: {
        true: 'admin.bonusPeriod.setDefault.true',
        false: 'admin.bonusPeriod.setDefault.false',
        setDefault: 'admin.bonusPeriod.setDefault.setDefault',
      },
      error: {
        overlapingBp: 'admin.bonusPeriod.error.overlapingBp',
      },

      form: {
        bonusPeriod: 'admin.bonusPeriod.form.bonusPeriod',
        name: 'admin.bonusPeriod.form.name',
        update: 'admin.bonusPeriod.form.update',
        create: 'admin.bonusPeriod.form.create',
        validFrom: 'admin.bonusPeriod.form.validFrom',
        validTo: 'admin.bonusPeriod.form.validTo',
        state: 'admin.bonusPeriod.form.state',
        organization: 'admin.bonusPeriod.form.organization',
        autoReviewCreationDates: 'admin.bonusPeriod.form.autoReviewCreationDates',
        goalsCheckExistence: 'admin.bonusPeriod.form.goalsCheckExistence',
        goalsCheckAgreed: 'admin.bonusPeriod.form.goalsCheckAgreed',
        goalsCheckFinished: 'admin.bonusPeriod.form.goalsCheckFinished',
        midYearReviewStart: 'admin.bonusPeriod.form.midYearReviewStart',
        midYearReviewNotification: 'admin.bonusPeriod.form.midYearReviewNotification',
        midYearReviewEnd: 'admin.bonusPeriod.form.midYearReviewEnd',
        endYearReviewStart: 'admin.bonusPeriod.form.endYearReviewStart',
        endYearReviewNotification: 'admin.bonusPeriod.form.endYearReviewNotification',
        endYearReviewEnd: 'admin.bonusPeriod.form.endYearReviewEnd',
      },

      table: {
        id: 'admin.bonusPeriod.table.id',
        name: 'admin.bonusPeriod.table.name',
        actions: 'admin.bonusPeriod.table.actions',
        state: 'admin.bonusPeriod.table.state',
        validFrom: 'admin.bonusPeriod.table.validFrom',
        validTo: 'admin.bonusPeriod.table.validTo',
        default: 'admin.bonusPeriod.table.default',
      },
    },

    mergeProfiles: {
      mergeDialogMessage: 'admin.mergeProfiles.mergeDialogMessage',
      findId: 'admin.mergeProfiles.findId',
      mergeIds: 'admin.mergeProfiles.mergeIds',
      personToMerge: 'admin.mergeProfiles.personToMerge',
      targetPerson: 'admin.mergeProfiles.targetPerson',
      hasOpenGoalsMsg: 'admin.mergeProfiles.hasOpenGoalsMsg',
      hasOpenReviewsMsg: 'admin.mergeProfiles.hasOpenReviewsMsg',
      hasOpenDevelopmentGoalsMsg: 'admin.mergeProfiles.hasOpenDevelopmentGoalsMsg',
    },

    reports: {
      label: 'admin.report.label',
      personGoals: 'admin.reports.personGoals',
      idp: 'admin.reports.idp',
      reviews: 'admin.reports.reviews',
      devGoals: 'admin.reports.devGoals',
      perfGoals: 'admin.reports.perfGoals',
      generated: 'admin.reports.generated',
    },
    persons: {
      label: 'admin.persons.label',
      duplicateDialog: {
        title: 'admin.persons.duplicateDialog.title',
        body: 'admin.persons.duplicateDialog.body',
        cancel: 'admin.persons.duplicateDialog.cancel',
        confirm: 'admin.persons.duplicateDialog.confirm',
      },

      duplicateMessages: {
        emailIsAlreadyUsed: 'admin.persons.duplicateMessages.emailIsAlreadyUsed',
        domainNameIsAlreadyUsed: 'admin.persons.duplicateMessages.domainNameIsAlreadyUsed',
        employeNumberIsAlreadyUsed: 'admin.persons.duplicateMessages.employeNumberIsAlreadyUsed',
        globalEmployeNumberIsAlreadyUsed: 'admin.persons.duplicateMessages.globalEmployeNumberIsAlreadyUsed',
        firstNameLastNameIsAlreadyUsed: 'admin.persons.duplicateMessages.firstNameLastNameIsAlreadyUsed',
      },

      form: {
        detail: 'admin.persons.form.detail',
        syncSwitchInfo: 'admin.persons.form.syncSwitchInfo',
        login: {
          loginType: 'admin.persons.form.login.loginType',
          domainName: 'admin.persons.form.login.domainName',
          userName: 'admin.persons.form.login.userName',
          userEmail: 'admin.persons.form.login.userEmail',
          loginTypes: {
            domain: 'admin.persons.form.login.loginTypes.domain',
            email: 'admin.persons.form.login.loginTypes.email',
          },
        },
        create: 'admin.persons.form.create',
        addIdentity: 'admin.persons.form.addIdentity',
        identification: 'admin.persons.form.identification',
        firstname: 'admin.persons.form.firstname',
        surname: 'admin.persons.form.surname',
        personId: 'admin.persons.form.personId',
        archived: 'admin.persons.form.archived',
        email: 'admin.persons.form.email',
        employeeNumber: 'admin.persons.form.employeeNumber',
        globalNumber: 'admin.persons.form.globalNumber',
        level: 'admin.persons.form.level',
        department: 'admin.persons.form.department',
        probationPeriodEnds: 'admin.persons.form.probationPeriodEnds',
        jobTitle: 'admin.persons.form.jobTitle',
        function: 'admin.persons.form.function',
        organization: 'admin.persons.form.organization',
        directManager: 'admin.persons.form.directManager',
        functionalManager: 'admin.persons.form.functionalManager',
        regionalDirector: 'admin.persons.form.regionalDirector',
        companyIdentity: 'admin.persons.form.companyIdentity',
        job: 'admin.persons.form.job',
        isExpat: 'admin.persons.form.isExpat',
        userIdentityManagement: 'admin.persons.form.userIdentityManagement',
        userRolesAndPermissions: 'admin.persons.form.userRolesAndPermissions',
        isAdministrator: 'admin.persons.form.isAdministrator',
        isFunctionalManager: 'admin.persons.form.isFunctionalManager',
        isHrPartner: 'admin.persons.form.isHrPartner',
        isOrgUnitAdmin: 'admin.persons.form.isOrgUnitAdmin',
        isRegionalDirector: 'admin.persons.form.isRegionalDirector',
        personalGoals: 'admin.persons.form.personalGoals',
        others: 'admin.persons.form.others',
        note: 'admin.persons.form.note',
        loginAs: 'admin.persons.form.loginAs',
        hrbp: 'admin.persons.form.hrbp',
        reviewRatios: 'admin.persons.form.reviewRatios',
        defaultOrganizationRatio: 'admin.persons.form.defaultOrganizationRatio',
        overridenRatio: 'admin.persons.form.overridenRatio',
        juniorOddyssey: 'admin.persons.form.juniorOddyssey',
        midOddyssey: 'admin.persons.form.midOddyssey',
        seniorOddyssey: 'admin.persons.form.seniorOddyssey',
        successorPersonInstanceId: 'admin.persons.form.successorPersonInstanceId',
        keyRole: 'admin.persons.form.keyRole',
      },

      table: {
        id: 'admin.persons.table.id',
        name: 'admin.persons.table.name',
        employeeNumber: 'admin.persons.table.employeeNumber',
        department: 'admin.persons.table.department',
        jobTitle: 'admin.persons.table.jobTitle',
        manager: 'admin.persons.table.manager',
        functionalManager: 'admin.persons.table.functionalManager',
        regionalDirector: 'admin.persons.table.regionalDirector',
        level: 'admin.persons.table.level',
        orgUnit: 'admin.persons.table.orgUnit',
        function: 'admin.persons.table.function',
        actions: 'admin.persons.table.actions',
      },
    },
    blogs: {
      label: 'admin.blogs.label',
      deleteDialogTitle: 'admin.blogs.deleteDialogTitle',
      deleteDialogText: 'admin.blogs.deleteDialogText',
      form: {
        create: 'admin.blogs.form.create',
        blog: 'admin.blogs.form.blog',
        update: 'admin.blogs.form.update',
        title: 'admin.blogs.form.title',
        content: 'admin.blogs.form.content',
        isPublished: 'admin.blogs.form.isPublished',
        image: 'admin.blogs.form.image',
        attachment: {
          warning: 'admin.blogs.form.attachment.warning',
        },
      },
      table: {
        id: 'admin.blogs.table.id',
        title: 'admin.blogs.table.title',
        created: 'admin.blogs.table.created',
        published: 'admin.blogs.table.published',
        actions: 'admin.blogs.table.actions',
      },
    },
    htmlEditor: {
      stripSuccessful: 'admin.htmlEditor.stripSuccessful',
    },
    adminActions: {
      label: 'admin.adminActions.label',
      bulkPublishButton: 'admin.adminActions.bulkPublishButton',
      bulkPublishConfirmTitle: 'admin.adminActions.bulkPublishConfirmTitle',
      bulkPublishConfirmBody: 'admin.adminActions.bulkPublishConfirmBody',
      bulkPublishSuccess: 'admin.adminActions.bulkPublishSuccess',
      filterExcoLevel: 'admin.adminActions.filterExcoLevel',
      filterAccountStatus: 'admin.adminActions.filterAccountStatus',
      filterReviewCycle: 'admin.adminActions.filterReviewCycle',
      filterReviewMidYear: 'admin.adminActions.filterReviewMidYear',
      filterReviewEndYear: 'admin.adminActions.filterReviewEndYear',
      filterBonusPeriod: 'admin.adminActions.filterBonusPeriod',
      filterAssessmentType: 'admin.adminActions.filterAssessmentType',
      filterAssessmentEmployee: 'admin.adminActions.filterAssessmentEmployee',
      filterAssessmentManager: 'admin.adminActions.filterAssessmentManager',
    },
    activityBar: {
      persons: 'admin.activityBar.persons',
      organizations: 'admin.activityBar.organizations',
      reports: 'admin.activityBar.reports',
      blogs: 'admin.activityBar.blogs',
      import: 'admin.activityBar.import',
      mergeProfiles: 'admin.activityBar.mergeProfiles',
      bonusPeriod: 'admin.activityBar.bonusPeriod',
      adminActions: 'admin.activityBar.adminActions',
      divisionMapping: 'admin.activityBar.divisionMapping',
      dashboard: 'admin.activityBar.dashboard',
      profile: 'admin.activityBar.profile',
      logout: 'admin.activityBar.logout',
    },
  },
  frontFace: {
    idp: {
      tooltip: {
        individualDevelopmentPlan: 'frontFace.idp.tooltip.individualDevelopmentPlan',
        performanceEvaluationOverview: 'frontFace.idp.tooltip.performanceEvaluationOverview',
        internationalMobility: 'frontFace.idp.tooltip.internationalMobility',
        aspiration: 'frontFace.idp.tooltip.aspiration',
      },
      sections: {
        individualDevelopmentPlan: 'frontFace.idp.sections.individualDevelopmentPlan',
        performanceEvaluationOverview: 'frontFace.idp.sections.performanceEvaluationOverview',
        internationalMobility: 'frontFace.idp.sections.internationalMobility',
        aspiration: 'frontFace.idp.sections.aspiration',
      },
      labels: {
        internationalMobility: 'frontFace.idp.labels.internationalMobility',
        aspiration: 'frontFace.idp.labels.aspiration',
        saveBtn: 'frontFace.idp.labels.saveBtn',
        historyBtn: 'frontFace.idp.labels.historyBtn',
        activeBtn: 'frontFace.idp.labels.activeBtn',
        from: 'frontFace.idp.labels.from',
        to: 'frontFace.idp.labels.to',
        action: 'frontFace.idp.labels.action',
        goals: 'frontFace.idp.labels.goals',
        leadershipQuality: 'frontFace.idp.labels.leadershipQuality',
        status: 'frontFace.idp.labels.status',
        approve: 'frontFace.idp.labels.approve',
        approved: 'frontFace.idp.labels.approved',
        disapprove: 'frontFace.idp.labels.disapprove',
        disapproved: 'frontFace.idp.labels.disapproved',
        pending: 'frontFace.idp.labels.pending',
        loading: 'frontFace.idp.labels.loading',
      },
      notifications: {
        qualityNotAvailable: 'frontFace.idp.notifications.qualityNotAvailable',
      },
    },
    activityBar: {
      personal: 'frontFace.activityBar.personal',
      team: 'frontFace.activityBar.team',
      myFormerTeam: 'frontFace.activityBar.myFormerTeam',
      functional: 'frontFace.activityBar.functional',
      regional: 'frontFace.activityBar.regional',
      admin: 'frontFace.activityBar.admin',
      allstars: 'frontFace.activityBar.allstars',
      profile: 'frontFace.activityBar.profile',
      reports: 'frontFace.activityBar.reports',
      logout: 'frontFace.activityBar.logout',
    },
    allstars: {
      heading: {
        subTitle: 'frontFace.allstars.heading.subTitle',
        title: 'frontFace.allstars.heading.title',
      },
      coreValueTag: {
        entepreneurial: 'frontFace.allstars.coreValueTag.entepreneurial',
        focused: 'frontFace.allstars.coreValueTag.focused',
        innovative: 'frontFace.allstars.coreValueTag.innovative',
        fair: 'frontFace.allstars.coreValueTag.fair',
      },
      dialog: {
        title: 'frontFace.allstars.dialog.title',
        labelNewStar: 'frontFace.allstars.dialog.labelNewStar',
        labelCoreValue: 'frontFace.allstars.dialog.labelCoreValue',
        labelMessage: 'frontFace.allstars.dialog.labelMessage',
        chooseCoreValue: 'frontFace.allstars.dialog.chooseCoreValue',
      },
      button: {
        newStar: 'frontFace.allstars.button.newStar',
      },
      noContentYet: {
        title: 'frontFace.allstars.noContentYet.title',
        description: 'frontFace.allstars.noContentYet.description',
      },
    },
    chatbot: {
      buttonText: 'frontFace.chatbot.buttonText',
      inputPlaceholder: 'frontFace.chatbot.inputPlaceholder',
      botIdle: 'frontFace.chatbot.botIdle',
    },
    common: {},
    developmentGoals: {
      states: {
        base: 'frontFace.developmentGoals.states',
        0: 'frontFace.developmentGoals.states.0',
        1: 'frontFace.developmentGoals.states.1',
        2: 'frontFace.developmentGoals.states.2',
        3: 'frontFace.developmentGoals.states.3',
        4: 'frontFace.developmentGoals.states.4',
        5: 'frontFace.developmentGoals.states.5',
        6: 'frontFace.developmentGoals.states.6',
        7: 'frontFace.developmentGoals.states.7',
        8: 'frontFace.developmentGoals.states.8',
      },
    },
    goals: {
      nullConfirmTitle: 'frontFace.goals.nullConfirmTitle',
      nullConfirmText: 'frontFace.goals.nullConfirmText',
      evaluationEmptyTitle: 'frontFace.goals.evaluationEmptyTitle',
      evaluationEmptyText: 'frontFace.goals.evaluationEmptyText',
      evaluationManagerFirstTitle: 'frontFace.goals.evaluationManagerFirstTitle',
      evaluationManagerFirstText: 'frontFace.goals.evaluationManagerFirstText',
      goal: 'frontFace.goals.goal',
      goalCount: 'frontFace.goals.goalCount',
      expandAll: 'frontFace.goals.expandAll',
      collapseAll: 'frontFace.goals.collapseAll',
      teamGoalCount: 'frontFace.goals.teamGoalCount',
      loadingGoals: 'frontFace.goals.loadingGoals',
      errorLoadingGoals: 'frontFace.goals.errorLoadingGoals',
      retry: 'frontFace.goals.retry',
      noGoals: 'frontFace.goals.noGoals',
      noGoalsDescription: 'frontFace.goals.noGoalsDescription',
      notYetProvided: 'frontFace.goals.notYetProvided',
      description: 'frontFace.goals.description',
      employeeEvaluation: 'frontFace.goals.employeeEvaluation',
      managerEvaluation: 'frontFace.goals.managerEvaluation',
      notRated: 'frontFace.goals.notRated',
      performance: 'frontFace.goals.performance',
      sortBy: 'frontFace.goals.sortBy',
      sortByAlphabetical: 'frontFace.goals.sortByAlphabetical',
      sortByStartDate: 'frontFace.goals.sortByStartDate',
      priorities: {
        base: 'frontFace.goals.priorities',
        0: 'frontFace.goals.priorities.0',
        1: 'frontFace.goals.priorities.1',
        2: 'frontFace.goals.priorities.2',
      },
      rating: {
        me: 'frontFace.goals.rating.me',
        manager: 'frontFace.goals.rating.manager',
      },
      states: {
        base: 'frontFace.goals.states',
        0: 'frontFace.goals.states.0',
        1: 'frontFace.goals.states.1',
        2: 'frontFace.goals.states.2',
        3: 'frontFace.goals.states.3',
        4: 'frontFace.goals.states.4',
        5: 'frontFace.goals.states.5',
        6: 'frontFace.goals.states.6',
        7: 'frontFace.goals.states.7',
        8: 'frontFace.goals.states.8',
        9: 'frontFace.goals.states.9',
      },
      statesEmployee: {
        base: 'frontFace.goals.statesEmployee',
        0: 'frontFace.goals.statesEmployee.0',
        1: 'frontFace.goals.statesEmployee.1',
        2: 'frontFace.goals.statesEmployee.2',
        3: 'frontFace.goals.statesEmployee.3',
        4: 'frontFace.goals.statesEmployee.4',
        5: 'frontFace.goals.statesEmployee.5',
        6: 'frontFace.goals.statesEmployee.6',
        7: 'frontFace.goals.statesEmployee.7',
        8: 'frontFace.goals.statesEmployee.6',
        9: 'frontFace.goals.statesEmployee.7',
      },
      types: {
        base: 'frontFace.goals.types',
        0: 'frontFace.goals.types.0',
        1: 'frontFace.goals.types.1',
        2: 'frontFace.goals.types.2',
      },
      actions: {
        assign: 'frontFace.goals.actions.assign',
        discuss: 'frontFace.goals.actions.discuss',
        agree: 'frontFace.goals.actions.agree',
        reject: 'frontFace.goals.actions.reject',
        rejectDialogTitle: 'frontFace.goals.actions.rejectDialogTitle',
        rejectDialogMessage: 'frontFace.goals.actions.rejectDialogMessage',
        rejectDialogCommentLabel: 'frontFace.goals.actions.rejectDialogCommentLabel',
        rejectDialogSubmit: 'frontFace.goals.actions.rejectDialogSubmit',
        rejectSuccess: 'frontFace.goals.actions.rejectSuccess',
        startEvaluation: 'frontFace.goals.actions.startEvaluation',
        approveEvaluation: 'frontFace.goals.actions.approveEvaluation',
        confirmCalibration: 'frontFace.goals.actions.confirmCalibration',
      },
      menu: {
        edit: 'frontFace.goals.menu.edit',
        discuss: 'frontFace.goals.menu.discuss',
        delete: 'frontFace.goals.menu.delete',
        expand: 'frontFace.goals.menu.expand',
        convert: 'frontFace.goals.menu.convert',
        convertError: 'frontFace.goals.menu.convertError',
        requestFeedback: 'frontFace.goals.menu.requestFeedback',
        toReview: 'frontFace.goals.menu.toReview',
        cancel: 'frontFace.goals.menu.cancel',
        reassign: 'frontFace.goals.menu.reassign',
      },
      tabs: {
        review: {
          title: 'frontFace.goals.tabs.review.title',
          descSelfEvaluation: 'frontFace.goals.tabs.review.descSelfEvaluation',
          descManagerEvaluation: 'frontFace.goals.tabs.review.descManagerEvaluation',
          managerEvaluation: 'frontFace.goals.tabs.review.managerEvaluation',
          selfEvaluation: 'frontFace.goals.tabs.review.selfEvaluation',
          achievedMetrics: 'frontFace.goals.tabs.review.achievedMetrics',
          submit: 'frontFace.goals.tabs.review.submit',
          saveDraft: 'frontFace.goals.tabs.review.saveDraft',
          valueText: 'frontFace.goals.tabs.review.valueText',
          selfEvalText: 'frontFace.goals.tabs.review.selfEvalText',
          noSupervisorDetected: 'frontFace.goals.tabs.review.noSupervisorDetected',
          reopenDialogTitle: 'frontFace.goals.tabs.review.reopenDialogTitle',
          reopenDialogComment: 'frontFace.goals.tabs.review.reopenDialogComment',
          reopenDialogSubmit: 'frontFace.goals.tabs.review.reopenDialogSubmit',
          reopenDialogCancel: 'frontFace.goals.tabs.review.reopenDialogCancel',
          approve: 'frontFace.goals.tabs.review.approve',
          reopen: 'frontFace.goals.tabs.review.reopen',
          completed: 'frontFace.goals.tabs.review.completed',
          notCompleted: 'frontFace.goals.tabs.review.notCompleted',
        },
        comment: 'frontFace.goals.tabs.comment',
        committee: 'frontFace.goals.tabs.committee',
        activity: {
          title: 'frontFace.goals.tabs.activity.title',
          filters: {
            all: 'frontFace.goals.tabs.activity.filters.all',
            comment: 'frontFace.goals.tabs.activity.filters.comment',
            milestone: 'frontFace.goals.tabs.activity.filters.milestone',
            feedback: 'frontFace.goals.tabs.activity.filters.feedback',
          },
          no: {
            comment: 'frontFace.goals.tabs.activity.no.comment',
            milestone: 'frontFace.goals.tabs.activity.no.milestone',
            feedback: 'frontFace.goals.tabs.activity.no.feedback',
          },
        },
      },
      create: 'frontFace.goals.create',
      createInfo: 'frontFace.goals.createInfo',
      teamGoalCreateInfo: 'frontFace.goals.teamGoalCreateInfo',
      createTeamGoal: 'frontFace.goals.createTeamGoal',
      export: 'frontFace.goals.export',
      goalsLink: 'frontFace.goals.goalsLink',

      deleteDialogMessage: 'frontFace.goals.deleteDialogMessage',
      convertDialogMessage: 'frontFace.goals.convertDialogMessage',
      cancelGoalDialogMessage: 'frontFace.goals.cancelGoalDialogMessage',

      teamGoal: 'frontFace.goals.teamGoal',
      teamGoalOwner: 'frontFace.goals.teamGoalOwner',
      teamGoalOwnerMyReviews: 'frontFace.goals.teamGoalOwnerMyReviews',
      teamGoals: 'frontFace.goals.teamGoals',
      performanceGoals: 'frontFace.goals.performanceGoals',
      label: 'frontFace.goals.label',
      comments: {
        placeholder: 'frontFace.goals.comments.placeholder',
        generated: {
          statusChange: 'frontFace.goals.comments.generated.statusChange',
          contentChange: 'frontFace.goals.comments.generated.contentChange',
        },
      },
      assignees: {
        title: 'frontFace.goals.assignees.title',
        title_plural: 'frontFace.goals.assignees.title_plural',
      },
      editor: {
        title: 'frontFace.goals.editor.title',
        titlePlaceholder: 'frontFace.goals.editor.titlePlaceholder',
        state: 'frontFace.goals.editor.state',
        description: 'frontFace.goals.editor.description',
        descriptionPlaceholder: 'frontFace.goals.editor.descriptionPlaceholder',
        priority: 'frontFace.goals.editor.priority',
        start: 'frontFace.goals.editor.start',
        due: 'frontFace.goals.editor.due',
        assignees: 'frontFace.goals.editor.assignees',
        assignToTeam: 'frontFace.goals.editor.assignToTeam',
        assignToFormerTeam: 'frontFace.goals.editor.assignToFormerTeam',
        formerTeamLabel: 'frontFace.goals.editor.formerTeamLabel',
        metrics: {
          add: 'frontFace.goals.editor.metrics.add',
          label: 'frontFace.goals.editor.metrics.label',
          min: 'frontFace.goals.editor.metrics.min',
          minPlaceholder: 'frontFace.goals.editor.metrics.minPlaceholder',
          max: 'frontFace.goals.editor.metrics.max',
          maxPlaceholder: 'frontFace.goals.editor.metrics.maxPlaceholder',
          target: 'frontFace.goals.editor.metrics.target',
          targetPlaceholder: 'frontFace.goals.editor.metrics.targetPlaceholder',
        },
        discardDialog: {
          title: 'frontFace.goals.editor.discardDialog.title',
          description: 'frontFace.goals.editor.discardDialog.description',
        },
      },
      greeter: {
        title: 'frontFace.goals.greeter.title',
        description: 'frontFace.goals.greeter.description',
        button: 'frontFace.goals.greeter.button',
      },
    },
    devGoals: {
      label: 'frontFace.devGoals.label',
      actionDivider: 'frontFace.devGoals.actionDivider',
      createInfo: 'frontFace.devGoals.createInfo',
      duration: {
        base: 'frontFace.devGoals.duration',
        1: 'frontFace.devGoals.duration.1',
        3: 'frontFace.devGoals.duration.3',
      },
      editor: {
        title: 'frontFace.devGoals.editor.title',
        titlePlaceholder: 'frontFace.devGoals.editor.titlePlaceholder',
        controlActions: 'frontFace.devGoals.editor.controlActions',
        controlActionsPlaceholder: 'frontFace.devGoals.editor.controlActionsPlaceholder',
        description: 'frontFace.devGoals.editor.description',
        descriptionPlaceholder: 'frontFace.devGoals.editor.descriptionPlaceholder',
        duration: 'frontFace.devGoals.editor.duration',
        state: 'frontFace.devGoals.editor.state',
        linkedGoals: 'frontFace.devGoals.editor.linkedGoals',
        discardDialog: {
          description: 'frontFace.devGoals.editor.discardDialog.description',
        },
        durationShortLabel: 'frontFace.devGoals.editor.durationShortLabel',
        durationLongLabel: 'frontFace.devGoals.editor.durationLongLabel',
      },
      menu: {
        edit: 'frontFace.devGoals.menu.edit',
        delete: 'frontFace.devGoals.menu.delete',
      },
    },
    teams: {
      label: 'frontFace.teams.label',
      member: 'frontFace.teams.member',
      teamLink: 'frontFace.teams.teamLink',
      teamCount: 'frontFace.teams.teamCount',
      regDirCount: 'frontFace.teams.regDirCount',
      funcManCount: 'frontFace.teams.funcManCount',
      exportTeamGoals: 'frontFace.teams.exportTeamGoals',
      flipButtonOverview: 'frontFace.teams.flipButtonOverview',
      flipButtonGoals: 'frontFace.teams.flipButtonGoals',
      viewProfile: 'frontFace.teams.viewProfile',
    },
    teamReviews: {
      label: 'frontFace.teamReviews.label',
      employee: 'frontFace.teamReviews.employee',
      perfGoal: 'frontFace.teamReviews.perfGoal',
      coreValues: 'frontFace.teamReviews.coreValues',
      overall: 'frontFace.teamReviews.overall',
      loadSubordinates: 'frontFace.teamReviews.loadSubordinates',
      export: 'frontFace.teamReviews.export',
      exportPdf: 'frontFace.teamReviews.exportPdf',
      employeeReview: {
        name: 'frontFace.teamReviews.employeeReview.name',
        perfGoal: 'frontFace.teamReviews.employeeReview.perfGoal',
        coreValue: 'frontFace.teamReviews.employeeReview.coreValue',
        overall: 'frontFace.teamReviews.employeeReview.overall',
        endYearSummary: 'frontFace.teamReviews.employeeReview.endYearSummary',
        finalScore: 'frontFace.teamReviews.employeeReview.finalScore',
      },
      changeGoalOwnerDialog: {
        header: 'frontFace.teamReviews.changeGoalOwnerDialog.header',
        selectTitle: 'frontFace.teamReviews.changeGoalOwnerDialog.selectTitle',
      },
    },
    functional: {
      team: 'frontFace.functional.team',
      reviews: 'frontFace.functional.reviews',
      reviewEmployee: 'frontFace.functional.employee',
      reviewPerfGoal: 'frontFace.functional.perfGoal',
      reviewCoreValues: 'frontFace.functional.coreValues',
      reviewOverall: 'frontFace.functional.overall',
      export: 'frontFace.functional.export',
      exportPdf: 'frontFace.functional.exportPdf',
    },
    regional: {
      team: 'frontFace.regional.team',
      reviews: 'frontFace.regional.reviews',
      reviewEmployee: 'frontFace.regional.employee',
      reviewPerfGoal: 'frontFace.regional.perfGoal',
      reviewCoreValues: 'frontFace.regional.coreValues',
      reviewOverall: 'frontFace.regional.overall',
      export: 'frontFace.regional.export',
      exportPdf: 'frontFace.regional.exportPdf',
    },
    blogs: {
      label: 'frontFace.blogs.label',
      showUnpublished: 'frontFace.blogs.showUnpublished',
      showPublished: 'frontFace.blogs.showPublished',
    },
    htmlEditor: {
      textSizeTooltip: 'frontFace.htmlEditor.textSizeTooltip',
      strikeTooltip: 'frontFace.htmlEditor.strikeTooltip',
      blockquoteTooltip: 'frontFace.htmlEditor.blockquoteTooltip',
      orderedListTooltip: 'frontFace.htmlEditor.orderedListTooltip',
      bulletListTooltip: 'frontFace.htmlEditor.bulletListTooltip',
      indentPlusTooltip: 'frontFace.htmlEditor.indentPlusTooltip',
      indentMinusTooltip: 'frontFace.htmlEditor.indentMinusTooltip',
      emojiTooltip: 'frontFace.htmlEditor.emojiTooltip',
      removeFormattingTooltip: 'frontFace.htmlEditor.removeFormattingTooltip',
      validateHtml: 'frontFace.htmlEditor.validateHtml',
    },
    reviews: {
      calibration: {
        title: 'frontFace.reviews.calibration.title',
        blank: 'frontFace.reviews.calibration.blank',
        managerCalibratedRatingValue: 'frontFace.reviews.calibration.managerCalibratedRatingValue',
        managerCalibrationNote: 'frontFace.reviews.calibration.managerCalibrationNote',
        managerRecommendationNote: 'frontFace.reviews.calibration.managerRecommendationNote',
        managerRecommendation: 'frontFace.reviews.calibration.managerRecommendation',
        managerNextSteps: 'frontFace.reviews.calibration.managerNextSteps',
        recommendationEnum0: 'frontFace.reviews.calibration.noAction',
        recommendationEnum1: 'frontFace.reviews.calibration.changeOfPosition',
        recommendationEnum2: 'frontFace.reviews.calibration.watchList',
        recommendationEnum3: 'frontFace.reviews.calibration.termination',
        recommendationEnum4: 'frontFace.reviews.calibration.development',
        recommendationEnum5: 'frontFace.reviews.calibration.oneToOne',
        recommendationEnum6: 'frontFace.reviews.calibration.specificAction',
      },
      label: 'frontFace.reviews.label',
      overview: 'frontFace.reviews.overview',
      actual: 'frontFace.reviews.actual',
      selfAssessment: 'frontFace.reviews.selfAssessment',
      managerAssessment: 'frontFace.reviews.managerAssessment',
      deleteDialogMessage: 'frontFace.reviews.deleteDialogMessage',
      deleteDialogTitle: 'frontFace.reviews.deleteDialogTitle',
      assessment: {
        states: {
          0: 'frontFace.reviews.assessment.states.0',
          5: 'frontFace.reviews.assessment.states.5',
          6: 'frontFace.reviews.assessment.states.6',
          7: 'frontFace.reviews.assessment.states.7',
        },
        locked: 'frontFace.reviews.assessment.locked',
      },
      type: {
        midYear: 'frontFace.reviews.type.midYear',
        probation: 'frontFace.reviews.type.probation',
        changePosition: 'frontFace.reviews.type.changePosition',
        endYear: 'frontFace.reviews.type.endYear',
        oneToOne: 'frontFace.reviews.type.oneToOne',
        leaveCompany: 'frontFace.reviews.type.leaveCompany',
        exit: 'frontFace.reviews.type.exit',
      },
      rating: {
        notThatGood: 'frontFace.reviews.rating.notThatGood',
        atTheEdge: 'frontFace.reviews.rating.atTheEdge',
        successful: 'frontFace.reviews.rating.successful',
        aboveExpectations: 'frontFace.reviews.ratingText.aboveExpectations',
        exceptionallyGood: 'frontFace.reviews.rating.exceptionallyGood',
      },
      ratingText: {
        notThatGood: 'frontFace.reviews.ratingText.notThatGood',
        notThatGoodDescription: 'frontFace.reviews.ratingText.notThatGoodDescription',
        notThatGoodDescriptionBold: 'frontFace.reviews.ratingText.notThatGoodDescriptionBoldText',
        atTheEdge: 'frontFace.reviews.ratingText.atTheEdge',
        atTheEdgeDescription: 'frontFace.reviews.ratingText.atTheEdgeDescription',
        atTheEdgeDescriptionBold: 'frontFace.reviews.ratingText.atTheEdgeDescriptionBoldText',
        successful: 'frontFace.reviews.ratingText.successful',
        aboveExpectations: 'frontFace.reviews.ratingText.aboveExpectations',
        exceptionallyGood: 'frontFace.reviews.ratingText.exceptionallyGood',
        exceptionallyGoodDescription: 'frontFace.reviews.ratingText.exceptionallyGoodDescription',
        exceptionallyGoodDescriptionBold: 'frontFace.reviews.ratingText.exceptionallyGoodDescriptionBoldText',
        aboveExpectationsDescription: 'frontFace.reviews.ratingText.aboveExpectationsDescription',
        aboveExpectationsDescriptionBold: 'frontFace.reviews.ratingText.aboveExpectationsDescriptionBoldText',
        meetExpectations: 'frontFace.reviews.ratingText.meetExpectations',
        meetExpectationsDescription: 'frontFace.reviews.ratingText.meetExpectationsDescription',
        meetExpectationsDescriptionBold: 'frontFace.reviews.ratingText.meetExpectationsDescriptionBoldText',
      },
      ratingIcon: {
        notThatGood: 'frontFace.reviews.ratingIcon.notThatGood',
        atTheEdge: 'frontFace.reviews.ratingIcon.atTheEdge',
        successful: 'frontFace.reviews.ratingIcon.successful',
        exceptionallyGood: 'frontFace.reviews.ratingIcon.exceptionallyGood',
        thumbsUp: 'frontFace.reviews.ratingIcon.thumbsUp',
        thumbsDown: 'frontFace.reviews.ratingIcon.thumbsDown',
      },
      coreValue: {
        beEntepreneurial: 'frontFace.reviews.coreValue.beEntepreneurial',
        beFocused: 'frontFace.reviews.coreValue.beFocused',
        beInnovative: 'frontFace.reviews.coreValue.beInnovative',
        beFair: 'frontFace.reviews.coreValue.beFair',
      },
      evaluateIndividualGoals: 'frontFace.reviews.evaluateIndividualGoals',
      noRatedYet: 'frontFace.reviews.noRatedYet',
      midYearHeader: 'frontFace.reviews.midYearHeader',
      endYearHeader: 'frontFace.reviews.endYearHeader',
      one2oneHeader: 'frontFace.reviews.one2oneHeader',
      probationHeader: 'frontFace.reviews.probationHeader',
      probationHint: 'frontFace.reviews.probationHint',
      leaveCompanyHeader: 'frontFace.reviews.leaveCompanyHeader',
      changePositionHeader: 'frontFace.reviews.changePositionHeader',
      exitHeader: 'frontFace.reviews.exitHeader',
      button: {
        new: 'frontFace.reviews.button.new',
        save: 'frontFace.reviews.button.save',
        saveAsDraft: 'frontFace.reviews.button.saveAsDraft',
        submit: 'frontFace.reviews.button.submit',
        reopen: 'frontFace.reviews.button.reopen',
        lock: 'frontFace.reviews.button.lock',
        unlock: 'frontFace.reviews.button.unlock',
        toggleEdit: 'frontFace.reviews.button.toggleEdit',
        toggleReadonly: 'frontFace.reviews.button.toggleReadonly',
        toggleFinished: 'frontFace.reviews.button.toggleFinished',
        toggleUnfinished: 'frontFace.reviews.button.toggleUnfinished',
        delete: 'frontFace.reviews.button.delete',
        changeReviewer: 'frontFace.reviews.button.changeReviewer',
        moveToDraft: 'frontFace.reviews.button.moveToDraft',
        moveToFinished: 'frontFace.reviews.button.moveToFinished',
      },

      exit: {
        dialogTitle: 'frontFace.reviews.exit.dialogTitle',
        dialogDescription: 'frontFace.reviews.exit.dialogDescription',
      },

      one2one: {
        topic: 'frontFace.reviews.one2one.topic',
        topicInfo: 'frontFace.reviews.one2one.topicInfo',
        discussion: 'frontFace.reviews.one2one.discussion',
        discussionInfo: 'frontFace.reviews.one2one.discussionInfo',
        nextSteps: 'frontFace.reviews.one2one.nextSteps',
        nextStepsInfo: 'frontFace.reviews.one2one.nextStepsInfo',
        actual: 'frontFace.reviews.one2one.actual',
        previous: 'frontFace.reviews.one2one.previous',
        noPrevious: 'frontFace.reviews.one2one.noPrevious',
        note: 'frontFace.reviews.one2one.note',
        noteInfo: 'frontFace.reviews.one2one.noteInfo',
        supervisor: 'frontFace.reviews.one2one.supervisor',
        supervisorDialogText: 'frontFace.reviews.one2one.supervisorDialogText',
        employeeTitle: 'frontFace.reviews.one2one.employeeTitle',
        managerTitle: 'frontFace.reviews.one2one.managerTitle',
      },
      employeeForm: {
        noSavedRating: 'frontFace.reviews.employeeForm.noSavedRating',
        performanceGoal: {
          label: 'frontFace.reviews.employeeForm.performanceGoal.label',
          valuePrefix: 'frontFace.reviews.employeeForm.performanceGoal.valuePrefix',
          valueSuffix: 'frontFace.reviews.employeeForm.performanceGoal.valueSuffix',
          description: 'frontFace.reviews.employeeForm.performanceGoal.description',
        },
        primaryCoreValue: {
          label: 'frontFace.reviews.employeeForm.primaryCoreValue.label',
          valuePrefix: 'frontFace.reviews.employeeForm.primaryCoreValue.valuePrefix',
          valueSuffix: 'frontFace.reviews.employeeForm.primaryCoreValue.valueSuffix',
          description: 'frontFace.reviews.employeeForm.primaryCoreValue.description',
        },
        secondaryCoreValue: {
          valuePrefix: 'frontFace.reviews.employeeForm.secondaryCoreValue.valuePrefix',
          valueSuffix: 'frontFace.reviews.employeeForm.secondaryCoreValue.valueSuffix',
          description: 'frontFace.reviews.employeeForm.secondaryCoreValue.description',
        },
        development: {
          label: 'frontFace.reviews.employeeForm.development.label',
          valuePrefix: 'frontFace.reviews.employeeForm.development.valuePrefix',
          valueSuffix: 'frontFace.reviews.employeeForm.development.valueSuffix',
          description: 'frontFace.reviews.employeeForm.development.description',
        },
        developmentSecondDescription: 'frontFace.reviews.employeeForm.developmentSecondDescription',
        overall: {
          label: 'frontFace.reviews.employeeForm.overall.label',
          valuePrefix: 'frontFace.reviews.employeeForm.overall.valuePrefix',
          valueSuffix: 'frontFace.reviews.employeeForm.overall.valueSuffix',
          description: 'frontFace.reviews.employeeForm.overall.description',
          myEvaluation: 'frontFace.reviews.employeeForm.overall.myEvaluation',
        },
        upcomingMonths: 'frontFace.reviews.employeeForm.upcomingMonths',
        upcomingMonthsLabel: 'frontFace.reviews.employeeForm.upcomingMonthsLabel',
        topic: 'frontFace.reviews.employeeForm.topic',
        topicLabel: 'frontFace.reviews.employeeForm.topicLabel',
        discussion: 'frontFace.reviews.employeeForm.discussion',
        discussionLabel: 'frontFace.reviews.employeeForm.discussionLabel',
        nextSteps: 'frontFace.reviews.employeeForm.nextSteps',
        nextStepsLabel: 'frontFace.reviews.employeeForm.nextStepsLabel',
        notes: 'frontFace.reviews.employeeForm.notes',
        notesLabel: 'frontFace.reviews.employeeForm.notesLabel',
      },
      managerForm: {
        noSavedRating: 'frontFace.reviews.managerForm.noSavedRating',
        performanceGoal: {
          label: 'frontFace.reviews.managerForm.performanceGoal.label',
          valuePrefix: 'frontFace.reviews.managerForm.performanceGoal.valuePrefix',
          valueSuffix: 'frontFace.reviews.managerForm.performanceGoal.valueSuffix',
          description: 'frontFace.reviews.managerForm.performanceGoal.description',
        },
        primaryCoreValue: {
          label: 'frontFace.reviews.managerForm.primaryCoreValue.label',
          valuePrefix: 'frontFace.reviews.managerForm.primaryCoreValue.valuePrefix',
          valueSuffix: 'frontFace.reviews.managerForm.primaryCoreValue.valueSuffix',
          description: 'frontFace.reviews.managerForm.primaryCoreValue.description',
        },
        secondaryCoreValue: {
          valuePrefix: 'frontFace.reviews.managerForm.secondaryCoreValue.valuePrefix',
          valueSuffix: 'frontFace.reviews.managerForm.secondaryCoreValue.valueSuffix',
          description: 'frontFace.reviews.managerForm.secondaryCoreValue.description',
        },
        development: {
          label: 'frontFace.reviews.managerForm.development.label',
          valuePrefix: 'frontFace.reviews.managerForm.development.valuePrefix',
          valueSuffix: 'frontFace.reviews.managerForm.development.valueSuffix',
          description: 'frontFace.reviews.managerForm.development.description',
        },
        developmentSecondDescription: 'frontFace.reviews.managerForm.developmentSecondDescription',
        overall: {
          label: 'frontFace.reviews.managerForm.overall.label',
          valuePrefix: 'frontFace.reviews.managerForm.overall.valuePrefix',
          valueSuffix: 'frontFace.reviews.managerForm.overall.valueSuffix',
          description: 'frontFace.reviews.managerForm.overall.description',
          myEvaluation: 'frontFace.reviews.managerForm.overall.myEvaluation',
        },
        upcomingMonths: 'frontFace.reviews.managerForm.upcomingMonths',
        upcomingMonthsLabel: 'frontFace.reviews.managerForm.upcomingMonthsLabel',
        topic: 'frontFace.reviews.employeeForm.topic',
        topicLabel: 'frontFace.reviews.employeeForm.topicLabel',
        discussion: 'frontFace.reviews.employeeForm.discussion',
        discussionLabel: 'frontFace.reviews.employeeForm.discussionLabel',
        nextSteps: 'frontFace.reviews.employeeForm.nextSteps',
        nextStepsLabel: 'frontFace.reviews.employeeForm.nextStepsLabel',
        notes: 'frontFace.reviews.employeeForm.notes',
        notesLabel: 'frontFace.reviews.employeeForm.notesLabel',
      },
      confirmDialog: {
        header: 'frontFace.reviews.confirmDialog.header',
        body: 'frontFace.reviews.confirmDialog.body',
      },
      valuesDialog: {
        header: 'frontFace.reviews.valuesDialog.header',
        body: 'frontFace.reviews.valuesDialog.body',
      },
      changeReviewerDialog: {
        header: 'frontFace.reviews.changeReviewerDialog.header',
        selectTitle: 'frontFace.reviews.changeReviewerDialog.selectTitle',
      },
      addCoreValue: 'frontFace.reviews.addCoreValue',
      hideCoreValue: 'frontFace.reviews.hideCoreValue',
      noReviews: {
        title: 'frontFace.reviews.noReviews.title',
      },
      noRights: {
        message: 'frontFace.reviews.noRights.message',
      },
      activeReviewExists: 'frontFace.reviews.activeReviewExists',
      sections: {
        finalComments: {
          info: 'frontFace.reviews.sections.finalComments.info',
          label: 'frontFace.reviews.sections.finalComments.label',
          rating: 'frontFace.reviews.sections.finalComments.rating',
          title: 'frontFace.reviews.sections.finalComments.title',
          placeholder: 'frontFace.reviews.sections.finalComments.placeholder',
        },
        textArea: {
          validMessage: 'frontFace.reviews.sections.textArea.validMessage',
          invalidMessage: 'frontFace.reviews.sections.textArea.invalidMessage',
        },
        aspiration: {
          title: 'frontFace.reviews.sections.aspiration.title',
          info: 'frontFace.reviews.sections.aspiration.info',
        },
        companyRating: {
          title: 'frontFace.reviews.sections.companyRating.title',
          info: 'frontFace.reviews.sections.companyRating.info',
          reset: 'frontFace.reviews.sections.companyRating.reset',
        },
        coreValues: {
          title: 'frontFace.reviews.sections.coreValues.title',
        },
        development: {
          title: 'frontFace.reviews.sections.development.title',
        },
        performanceGoals: {
          title: 'frontFace.reviews.sections.performanceGoals.title',
        },
        finalScore: {
          title: 'frontFace.reviews.sections.finalScore.title',
          info: 'frontFace.reviews.sections.finalScore.info',
        },
        functionalQualities: {
          title: 'frontFace.reviews.sections.functionalQualities.title',
          hintMessage: 'frontFace.reviews.sections.functionalQualities.hintMessage',
          hintMessageWithClickHereVariable:
            'frontFace.reviews.sections.functionalQualities.hintMessageWithClickHereVariable',
          hintMessageClickHere: 'frontFace.reviews.sections.functionalQualities.hintMessageClickHere',
        },
        leadershipQualities: {
          title: 'frontFace.reviews.sections.leadershipQualities.title',
          hintMessage: 'frontFace.reviews.sections.leadershipQualities.hintMessage',
          hintMessageWithClickHereVariable:
            'frontFace.reviews.sections.leadershipQualities.hintMessageWithClickHereVariable',
          hintMessageClickHere: 'frontFace.reviews.sections.leadershipQualities.hintMessageClickHere',
          noComment: 'frontFace.reviews.sections.leadershipQualities.noComment',
          noEvaluation: 'frontFace.reviews.sections.leadershipQualities.noEvaluation',
          toastr: {
            saved: 'frontFace.reviews.sections.leadershipQualities.toastr.saved',
          },
          modal: {
            title: 'frontFace.reviews.sections.leadershipQualities.modal.title',
          },
          table: {
            name: 'frontFace.reviews.sections.leadershipQualities.table.name',
            employeeComment: 'frontFace.reviews.sections.leadershipQualities.table.employeeComment',
            managerComment: 'frontFace.reviews.sections.leadershipQualities.table.managerComment',
            evaluation: 'frontFace.reviews.sections.leadershipQualities.table.evaluation',
            editBtn: 'frontFace.reviews.sections.leadershipQualities.table.editBtn',
            evaluateBtn: 'frontFace.reviews.sections.leadershipQualities.table.evaluateBtn',
            showBtn: 'frontFace.reviews.sections.leadershipQualities.table.showBtn',
            description: 'frontFace.reviews.sections.leadershipQualities.table.description',
            proficiencyLevelsReference:
              'frontFace.reviews.sections.leadershipQualities.table.proficiencyLevelsReference',
            action: 'frontFace.reviews.sections.leadershipQualities.table.action',
          },
          evaluation: {
            short: {
              no: 'frontFace.reviews.sections.leadershipQualities.evaluation.short.no',
              mostly: 'frontFace.reviews.sections.leadershipQualities.evaluation.short.mostly',
              yes: 'frontFace.reviews.sections.leadershipQualities.evaluation.short.yes',
              significantlyBelow: 'frontFace.reviews.sections.leadershipQualities.evaluation.short.significantlyBelow',
              below: 'frontFace.reviews.sections.leadershipQualities.evaluation.short.below',
              onPar: 'frontFace.reviews.sections.leadershipQualities.evaluation.short.onPar',
              above: 'frontFace.reviews.sections.leadershipQualities.evaluation.short.above',
              exceptional: 'frontFace.reviews.sections.leadershipQualities.evaluation.short.exceptional',
              needsImprovement: 'frontFace.reviews.sections.leadershipQualities.evaluation.short.needsImprovement',
              meetsExpectations: 'frontFace.reviews.sections.leadershipQualities.evaluation.short.meetsExpectations',
              aboveExpectations: 'frontFace.reviews.sections.leadershipQualities.evaluation.short.aboveExpectations',
            },
            long: {
              no: 'frontFace.reviews.sections.leadershipQualities.evaluation.long.no',
              mostly: 'frontFace.reviews.sections.leadershipQualities.evaluation.long.mostly',
              yes: 'frontFace.reviews.sections.leadershipQualities.evaluation.long.yes',
              significantlyBelow: 'frontFace.reviews.sections.leadershipQualities.evaluation.long.significantlyBelow',
              below: 'frontFace.reviews.sections.leadershipQualities.evaluation.long.below',
              onPar: 'frontFace.reviews.sections.leadershipQualities.evaluation.long.onPar',
              above: 'frontFace.reviews.sections.leadershipQualities.evaluation.long.above',
              exceptional: 'frontFace.reviews.sections.leadershipQualities.evaluation.long.exceptional',
              needsImprovement: 'frontFace.reviews.sections.leadershipQualities.evaluation.long.needsImprovement',
              meetsExpectations: 'frontFace.reviews.sections.leadershipQualities.evaluation.long.meetsExpectations',
              aboveExpectations: 'frontFace.reviews.sections.leadershipQualities.evaluation.long.aboveExpectations',
            },
          },
          asterisk: 'quality.asterisk.description',
        },
        goals: {
          title: 'frontFace.reviews.sections.goals.title',
          name: 'frontFace.reviews.sections.goals.name',
          type: 'frontFace.reviews.sections.goals.type',
          priority: 'frontFace.reviews.sections.goals.priority',
          weight: 'frontFace.reviews.sections.goals.weight',
          weightDescription: 'frontFace.reviews.sections.goals.weightDescription',
          employee: 'frontFace.reviews.sections.goals.employee',
          manager: 'frontFace.reviews.sections.goals.manager',
          performance: 'frontFace.reviews.sections.goals.performance',
          team: 'frontFace.reviews.sections.goals.team',
          overall: 'frontFace.reviews.sections.goals.overall',
          info: 'frontFace.reviews.sections.goals.info',
          oldGoalInfo: 'frontFace.reviews.sections.goals.oldGoalInfo',
          secDescription: 'frontFace.reviews.sections.goals.secDescription',
          fromReview: {
            addNewComment: 'frontFace.reviews.sections.goals.fromReview.addNewComment',
            cancelComment: 'frontFace.reviews.sections.goals.fromReview.cancelComment',
          },
          here: 'frontFace.reviews.sections.goals.here',
          calibration: 'frontFace.reviews.sections.goals.calibration',
          evaluation: {
            short: {
              selectOption: 'frontFace.reviews.sections.goals.evaluation.short.selectOption',
              significantbelow: 'frontFace.reviews.sections.goals.evaluation.short.significantbelow',
              below: 'frontFace.reviews.sections.goals.evaluation.short.below',
              onPar: 'frontFace.reviews.sections.goals.evaluation.short.onPar',
              above: 'frontFace.reviews.sections.goals.evaluation.short.above',
              excellent: 'frontFace.reviews.sections.goals.evaluation.short.excellent',
              notEvaluated: 'frontFace.reviews.sections.goals.evaluation.short.notEvaluated',
            },
            long: {
              selectOption: 'frontFace.reviews.sections.goals.evaluation.long.selectOption',
              significantbelow: 'frontFace.reviews.sections.goals.evaluation.long.significantbelow',
              below: 'frontFace.reviews.sections.goals.evaluation.long.below',
              onPar: 'frontFace.reviews.sections.goals.evaluation.long.onPar',
              above: 'frontFace.reviews.sections.goals.evaluation.long.above',
              excellent: 'frontFace.reviews.sections.goals.evaluation.long.excellent',
              notEvaluated: 'frontFace.reviews.sections.goals.evaluation.long.notEvaluated',
            },
          },
          evaluateButtonHeader: 'frontFace.reviews.sections.goals.goalEvaluateButtonHeader',
          evaluateButtonCaptions: 'frontFace.reviews.sections.goals.goalEvaluateButtonCaptions',
        },
        period: {
          title: 'frontFace.reviews.sections.period.title',
          employeeDescription: 'frontFace.reviews.sections.period.employeeDescription',
          managerDescription: 'frontFace.reviews.sections.period.managerDescription',
          employeeEvaluation: 'frontFace.reviews.sections.period.employeeEvaluation',
          managerEvaluation: 'frontFace.reviews.sections.period.managerEvaluation',
          managerValueText: 'frontFace.reviews.sections.period.managerValueText',
        },
        prefill: {
          employee: 'frontFace.reviews.sections.prefill.button.employee',
          manager: 'frontFace.reviews.sections.prefill.button.manager',
          modalTitle: 'frontFace.reviews.sections.prefill.modal.header',
          modalBody: 'frontFace.reviews.sections.prefill.modal.body',
        },
        overallPercentage: {
          managerEvaluation: 'frontFace.reviews.sections.overallPercentage.managerEvaluation',
        },
        overall: {
          title: 'frontFace.reviews.sections.overall.title',
          employeeDescription: 'frontFace.reviews.sections.overall.employeeDescription',
          managerDescription: 'frontFace.reviews.sections.overall.managerDescription',
          employeeEvaluation: 'frontFace.reviews.sections.overall.employeeEvaluation',
          managerEvaluation: 'frontFace.reviews.sections.overall.managerEvaluation',
          employeeFirstQuestion: 'frontFace.reviews.sections.overall.employeeFirstQuestion',
          managerFirstQuestion: 'frontFace.reviews.sections.overall.managerFirstQuestion',
          employeeSecondQuestion: 'frontFace.reviews.sections.overall.employeeSecondQuestion',
          managerSecondQuestion: 'frontFace.reviews.sections.overall.managerSecondQuestion',
          employeeThirdQuestion: 'frontFace.reviews.sections.overall.employeeThirdQuestion',
          managerThirdQuestion: 'frontFace.reviews.sections.overall.managerThirdQuestion',
          dropDownTitle: 'frontFace.reviews.sections.finalComments.rating',
          reflection: {
            title: 'frontFace.reviews.sections.reflection.title',
            employeeHintMessage: 'frontFace.reviews.sections.reflection.employeeHintMessage',
            managerHintMessage: 'frontFace.reviews.sections.reflection.managerHintMessage',
          },
        },
        tellus: {
          title: 'frontFace.reviews.sections.tellus.title',
          noAnswer: 'frontFace.reviews.sections.tellus.noAnswer',
          info: 'frontFace.reviews.sections.tellus.info',
        },
        committeeChat: {
          messages: 'frontFace.reviews.sections.committeeChat.messages',
          wroteRecently: 'frontFace.reviews.sections.committeeChat.wroteRecently',
          title: 'frontFace.reviews.sections.committeeChat.title',
        },
        linkedMidYear: {
          title: 'frontFace.reviews.sections.linkedMidYear.title',
          info: 'frontFace.reviews.sections.linkedMidYear.info',
          link: 'frontFace.reviews.sections.linkedMidYear.link',
        },
        whatsNext: {
          title: 'frontFace.reviews.sections.whatsNext.title',
        },
        finalSummary: {
          title: 'frontFace.reviews.sections.finalComments.title',
          hint: 'frontFace.reviews.sections.finalComments.info',
          employeeHintMessage: 'frontFace.reviews.sections.finalSummary.employeeHintMessage',
          managerHintMessage: 'frontFace.reviews.sections.finalSummary.managerHintMessage',
        },
        topic: {
          title: 'frontFace.reviews.sections.topic.title',
        },
        discussion: {
          title: 'frontFace.reviews.sections.discussion.title',
        },
        nextSteps: {
          title: 'frontFace.reviews.sections.nextSteps.title',
        },
        notes: {
          title: 'frontFace.reviews.sections.notes.title',
        },
      },
    },
    feedback: {
      label: 'frontFace.feedback.label',
      activity: 'frontFace.feedback.activity',
      archive: 'frontFace.feedback.archive',
      mentions: 'frontFace.feedback.mentions',
      mentioned: 'frontFace.feedback.mentioned',
      myReply: 'frontFace.feedback.myReply',
      replyOn: 'frontFace.feedback.replyOn',
      onBehalfOf: 'frontFace.feedback.onBehalfOf',
      requestedBy: 'frontFace.feedback.requestedBy',
      deleteDialogTitle: 'frontFace.feedback.deleteDialogTitle',
      deleteDialogText: 'frontFace.feedback.deleteDialogText',
      noFeedbacks: {
        title: 'frontFace.feedback.noFeedbacks.title',
        description: 'frontFace.feedback.noFeedbacks.description',
      },
      requestFeedback: 'frontFace.feedback.requestFeedback',
      provideFeedback: 'frontFace.feedback.provideFeedback',
      provideFeedbackDialog: {
        title: 'frontFace.feedback.provideFeedbackDialog.title',
        recipients: 'frontFace.feedback.provideFeedbackDialog.recipients',
        message: 'frontFace.feedback.provideFeedbackDialog.message',
        mention: 'frontFace.feedback.provideFeedbackDialog.mention',
        confirm: 'frontFace.feedback.provideFeedbackDialog.confirm',
        cancel: 'frontFace.feedback.provideFeedbackDialog.cancel',
        mentionText: 'frontFace.feedback.provideFeedbackDialog.mentionText',
      },
      requestHeading: 'frontFace.feedback.requestHeading',
      requestFrom: 'frontFace.feedback.requestFrom',
      requestTo: 'frontFace.feedback.requestTo',
      requestSend: 'frontFace.feedback.requestSend',
      respond: 'frontFace.feedback.respond',
      reply: {
        confirm: 'frontFace.feedback.reply.confirm',
        cancel: 'frontFace.feedback.reply.cancel',
        label: 'frontFace.feedback.reply.label',
        success: 'frontFace.feedback.reply.success',
      },
      requestFeedbackDialog: {
        title: 'frontFace.feedback.requestFeedbackDialog.title',
        from: 'frontFace.feedback.requestFeedbackDialog.from',
        onBehalfInfo: 'frontFace.feedback.requestFeedbackDialog.onBehalfInfo',
        message: 'frontFace.feedback.requestFeedbackDialog.message',
        goal: 'frontFace.feedback.requestFeedbackDialog.goal',
        confirm: 'frontFace.feedback.requestFeedbackDialog.confirm',
        cancel: 'frontFace.feedback.requestFeedbackDialog.cancel',
        copyBtnTitle: 'frontFace.feedback.requestFeedbackDialog.copyBtnTitle',
        goalTitle: 'frontFace.feedback.requestFeedbackDialog.goalTitle',
      },
      type: {
        person: 'frontFace.feedback.type.person',
        goal: 'frontFace.feedback.type.goal',
        allstar: 'frontFace.feedback.type.allstar',
        unrequested: 'frontFace.feedback.type.unrequested',
      },
    },

    feedbackForm: {
      button: 'frontFace.feedbackForm.button',
      thankyou: 'frontFace.feedbackForm.thankyou',
      thankyouMessage: 'frontFace.feedbackForm.thankyouMessage',
      improve: 'frontFace.feedbackForm.improve',
      info: 'frontFace.feedbackForm.info',
      rate: 'frontFace.feedbackForm.rate',
      comment: {
        label: 'frontFace.feedbackForm.comment.label',
        placeholder: 'frontFace.feedbackForm.comment.placeholder',
      },
      send: 'frontFace.feedbackForm.send',
    },

    myDevelopment: {
      label: 'frontFace.myDevelopment.label',
      current: 'frontFace.myDevelopment.current',
      archive: 'frontFace.myDevelopment.archive',
      archiveButton: 'frontFace.myDevelopment.archiveButton',
      create: 'frontFace.myDevelopment.create',
      noCurrentPlan: 'frontFace.myDevelopment.noCurrentPlan',
      noContentYet: 'frontFace.myDevelopment.noContentYet',
      toggleEdit: 'frontFace.myDevelopment.toggleEdit',
      toggleReadonly: 'frontFace.myDevelopment.toggleReadonly',
      export: 'frontFace.myDevelopment.export',
      archiveIdpDialogHeader: 'frontFace.myDevelopment.archiveIdpDialogHeader',
      archiveIdpDialogBody: 'frontFace.myDevelopment.archiveIdpDialogBody',
      form: {
        heading: 'frontFace.myDevelopment.form.heading',
        submit: 'frontFace.myDevelopment.form.submit',
        aspiration: 'frontFace.myDevelopment.form.aspiration',
        reality: 'frontFace.myDevelopment.form.reality',
        experience: 'frontFace.myDevelopment.form.experience',
        learning: 'frontFace.myDevelopment.form.learning',
        interest: 'frontFace.myDevelopment.form.interest',
        aspirationHint: 'frontFace.myDevelopment.form.aspirationHint',
        realityHint: 'frontFace.myDevelopment.form.realityHint',
      },
      noIdps: {
        title: 'frontFace.myDevelopment.noIdps.title',
        description: 'frontFace.myDevelopment.noIdps.description',
      },
    },

    shared: {
      discardDialog: {
        title: 'frontFace.shared.discardDialog.title',
        defaultBodyText: 'frontFace.shared.discardDialog.defaultBodyText',
      },
      notFilledValuesDialog: {
        title: 'frontFace.shared.notFilledValuesDialog.title',
        bodyTextPrimaryCoreValue: 'frontFace.shared.notFilledValuesDialog.bodyTextPrimaryCoreValue',
        bodyTextDevelopmentValue: 'frontFace.shared.notFilledValuesDialog.bodyTextDevelopmentValue',
        bodyTextEndYearOverallValue: 'frontFace.shared.notFilledValuesDialog.bodyTextEndYearOverallValue',
        bodyTextPerformanceGoalsValue: 'frontFace.shared.notFilledValuesDialog.bodyTextPerformanceGoalsValue',
        bodyTextMidYearOverallValue: 'frontFace.shared.notFilledValuesDialog.bodyTextMidYearOverallValue',
      },
    },
  },
  reports: {
    devGoals: {
      table: {
        name: 'reports.devGoals.table.name',
        employeeNumber: 'reports.devGoals.table.employeeNumber',
        department: 'reports.devGoals.table.department',
        title: 'reports.devGoals.table.title',
        duration: 'reports.devGoals.table.duration',
        actions: 'reports.devGoals.table.actions',
      },
    },
    perfGoals: {
      table: {
        name: 'reports.perfGoals.table.name',
        employeeNumber: 'reports.perfGoals.table.employeeNumber',
        department: 'reports.perfGoals.table.department',
        title: 'reports.perfGoals.table.title',
        state: 'reports.perfGoals.table.state',
        priority: 'reports.perfGoals.table.priority',
        due: 'reports.perfGoals.table.due',
        personalRating: 'reports.perfGoals.table.personalRating',
        managerRating: 'reports.perfGoals.table.managerRating',
      },
    },
    goal: {
      table: {
        name: 'reports.goal.table.name',
        employeeNumber: 'reports.goal.table.employeeNumber',
        department: 'reports.goal.table.department',
        discussionGoalsCount: 'reports.goal.table.discussionGoalsCount',
        approvedGoalsCount: 'reports.goal.table.approvedGoalsCount',
        actions: 'reports.goal.table.actions',
      },
    },
    idp: {
      table: {
        name: 'reports.idp.table.name',
        employeeNumber: 'reports.idp.table.employeeNumber',
        department: 'reports.idp.table.department',
        level: 'reports.idp.table.level',
        function: 'reports.idp.table.function',
        aspiration: 'reports.idp.table.aspiration',
        reality: 'reports.idp.table.reality',
        experience: 'reports.idp.table.experience',
        learning: 'reports.idp.table.learning',
        interest: 'reports.idp.table.interest',
      },
    },
    review: {
      table: {
        name: 'reports.review.table.name',
        employeeNumber: 'reports.review.table.employeeNumber',
        department: 'reports.review.table.department',
        function: 'reports.review.table.function',
        state: 'reports.review.table.state',
        reviewType: 'reports.review.table.reviewType',
        managerOverall: 'reports.review.table.managerOverall',
        actions: 'reports.review.table.actions',
      },
    },
  },
  shared: {
    requiredIndicator: 'shared.requiredIndicator',
    syncControl: {
      edit: 'shared.syncControl.edit',
      overriden: 'shared.syncControl.overriden',
    },
    personPanel: {
      goals: 'shared.personPanel.goals',
      team: 'shared.personPanel.team',
      orgChart: 'shared.personPanel.orgChart',
      idp: 'shared.personPanel.idp',
      feedbacks: 'shared.personPanel.feedbacks',
      reviews: 'shared.personPanel.reviews',
      teamGoals: 'shared.personPanel.teamGoals',
      teamReviews: 'shared.personPanel.teamReviews',
      functionalManagerReviews: 'shared.personPanel.functionalManagerReviews',
      regionalManagerReviews: 'shared.personPanel.regionalManagerReviews',
      formerTeam: 'shared.personPanel.formerTeam',
    },
    simpleSlider: {
      toggleInput: 'shared.simpleSlider.toggleInput',
    },
    pagination: {
      paginationInfo: 'shared.pagination.paginationInfo',
      previous: 'shared.pagination.previous',
      first: 'shared.pagination.first',
      next: 'shared.pagination.next',
      last: 'shared.pagination.last',
    },
  },
  validations: {
    required: 'validation.required',
    requiredWhenPublishing: 'validation.requiredWhenPublishing',
    maxCharactersExceeded: 'validation.maxCharactersExceeded',
    mustBeNumber: 'validation.mustBeNumber',
    minValue: 'validation.minValue',
    maxValue: 'validation.maxValue',
    minLen: 'validation.minLen',
    maxLen: 'validation.maxLen',
    email: 'validation.email',
    date: 'validation.date',
    notEqual: 'validation.notEqual',

    custom: {
      directManagerNotEqual: 'validations.custom.directManagerNotEqual',
      functionalManagerNotEqual: 'validations.custom.functionalManagerNotEqual',
      regionalDirectorNotEqual: 'validations.custom.regionalDirectorNotEqual',
    },
  },
  personProfile: {
    headers: {
      companyIdentity: 'personProfile.headers.companyIdentity',
      job: 'personProfile.headers.job',
      userIdentityManagement: 'personProfile.headers.userIdentityManagement',
      settings: 'personProfile.headers.settings',
      achievments: 'personProfile.headers.achievments',
      uploadTitle: 'personProfile.headers.uploadTitle',
      hrContacts: 'personProfile.headers.hrContacts',
      changeLanguage: 'personProfile.headers.changeLanguage',
    },
    changeLanguageDialog: {
      body: 'personProfile.changeLanguageDialog.body',
    },
    labels: {
      email: 'personProfile.labels.email',
      employeeNumber: 'personProfile.labels.employeeNumber',
      level: 'personProfile.labels.level',
      probationPeriodEnds: 'personProfile.labels.probationPeriodEnds',
      localNumber: 'personProfile.labels.localNumber',
      isExpat: 'personProfile.labels.isExpat',
      jobTitle: 'personProfile.labels.jobTitle',
      function: 'personProfile.labels.function',
      organization: 'personProfile.labels.organization',
      directManager: 'personProfile.labels.directManager',
      functionalManager: 'personProfile.labels.functionalManager',
      regionalDirector: 'personProfile.labels.regionalDirector',
      sentEmailNotifications: 'personProfile.labels.sentEmailNotifications',
      immediately: 'personProfile.labels.immediately',
      daily: 'personProfile.labels.daily',
      weekly: 'personProfile.labels.weekly',
      never: 'personProfile.labels.never',
      uploadPhoto: 'personProfile.labels.uploadPhoto',
      orgAdmins: 'personProfile.labels.orgAdmins',
      hrBp: 'personProfile.labels.hrBp',
      language: 'personProfile.labels.language',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/app.i18n.ts